<template>
  <dialogWrap :dialogShow="handelDialogVisible" :title="title" :before-close="closeDialog" width="900px">
    <el-form :model="formData" ref="form" label-width="140px" :rules="rules" :inline="true">
      <template v-if="byLease">
        <el-form-item prop="downPayment" label="首付金额（元）:">
          <el-input v-model="formData.downPayment" placeholder="请输入" clearable @input="inputEvent">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="leasePeriods" label="租赁期数:">
          <el-input v-model="formData.leasePeriods" placeholder="请输入" clearable @input="inputEvent">
            <template slot="append">期</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="rent" label="月租金（元）:">
          <el-input v-model="formData.rent" placeholder="请输入" clearable @input="inputEvent">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="yearRate" label="年利率:">
          <el-input v-model="formData.yearRate" placeholder="请输入" clearable v-number:percent.max100 @input="inputEvent">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="margin" label="保证金/押金（元）:">
          <el-input v-model="formData.margin" placeholder="请输入" clearable>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="commission" label="手续费（元）:">
          <el-input v-model="formData.commission" placeholder="请输入" clearable @input="inputEvent">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="irr">
          <template slot="label">
            <span>内部收益率(IRR)&nbsp;</span>
            <el-tooltip placement="top">
              <div slot="content">资金流入现值总额与资金流出现值总额相等、净现值等于零时的折现率。代表投资期望达到的报酬率，指标越大越好，内部收益率>基准收益率时，项目可行。</div>
              <i class="el-icon-question" />
            </el-tooltip>
          </template>
          <span class='irrSpan'>{{formData.irr ? `${formData.irr}%` : '--'}}</span>
          <el-button type="text" @click="getIrrEvent" :loading="loading">计算</el-button>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item prop="rent" label="月租金（元）:">
          <el-input v-model="formData.rent" placeholder="请输入" clearable>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="leasePeriods" label="租期:">
          <el-input v-model="formData.leasePeriods" placeholder="请输入" clearable>
            <template slot="append">期</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="margin" label="押金:">
          <el-input v-model="formData.margin" placeholder="请输入" clearable>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
      </template>
    </el-form>
    <template #footer>
      <div>
        <el-button @click="closeDialog">取消</el-button>
        <el-button @click="submit" type="primary" :loading="loading">确认</el-button>
      </div>
    </template>
  </dialogWrap>
</template>

<script>
import { validatorInterest } from '@/utils/validate'
import { infoManageIrr } from '@/api/carResource/index.js'
// import _ from 'lodash'

const ruleAppend = { validator: validatorInterest, trigger: ['blur'], max: 1000000 }

export default {
  props: {
    searchForm: {
      type: Object,
      default: () => ({}),
    },
    byLease: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'add',
    },
  },
  data() {
    return {
      formData: {
        downPayment: '',
        leasePeriods: '',
        rent: '',
        yearRate: '',
        margin: '',
        commission: '',
        irr: '',
      },
      loading: false,
      handelDialogVisible: false,
    }
  },
  created() {
    // this.debounceGetIrrValue = _.debounce(this.getIrrValue, 500)
  },
  computed: {
    title() {
      return this.type === 'add' ? '新建方案' : '编辑方案'
    },
    rules() {
      return {
        downPayment: [{ required: true, ...ruleAppend }],
        leasePeriods: [{ required: true, ...ruleAppend, max: 100, integer: true }],
        rent: [{ required: true, ...ruleAppend }],
        yearRate: [{ required: true, message: '请输入', trigger: 'blur' }],
        margin: [{ required: !this.byLease, ...ruleAppend }],
        commission: [{ required: false, ...ruleAppend }],
      }
    },
  },
  methods: {
    inputEvent(/* val, flag */) {
      /* const { downPayment, leasePeriods, yearRate, rent } = this.formData
      const reg = /^[0-9]+(\.[0-9]{1,2})?$/
      // 其他四个必填项都填写 && 填写的是纯数字，可包含最多两位小数，再请求接口计算。只有是手续费时可以不填，即为空
      if (reg.test(downPayment) && /^\d+$/.test(leasePeriods) && reg.test(yearRate) && reg.test(rent) && (reg.test(val) || (flag && !val))) {
        this.debounceGetIrrValue()
      } */
      this.formData.irr = ''
    },
    getIrrEvent() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.getIrrValue()
        }
      })
    },
    getIrrValue() {
      if (!this.handelDialogVisible) return
      this.loading = true
      const { downPayment, leasePeriods, yearRate, rent, commission } = this.formData
      const { unitPrice } = this.searchForm
      const params = { downPayment, leasePeriods, yearRate, rent, commission, unitPrice }
      infoManageIrr(params).then((res) => {
        const { code, data } = res || {}
        if (code === 1) {
          this.formData.irr = data
        }
      }).finally(() => {
        this.loading = false
      })
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          /* if (this.byLease && !this.formData.irr) {
            this.$message.error('请先计算内部收益率')
            return
          } */
          this.submitConfirm()
        }
      })
    },
    async submitConfirm() {
      const rowData = { ...this.formData }
      /* for (const i in rowData) {
        // 去除 ''和undefined
        if (!rowData[i]) {
          delete rowData[i]
        }
      } */
      if (this.type === 'add') {
        this.$emit('addRow', rowData)
      } else {
        this.$emit('editRow', rowData)
      }
      this.closeDialog()
      this.$message({ type: 'success', message: `${this.title}成功` })
    },
    closeDialog() {
      this.$refs.form.resetFields()
      this.handelDialogVisible = false
    },
    // eslint-disable-next-line vue/no-unused-properties
    openDialog(row) {
      if (row) {
        // nextTick后填充表单，防止关闭弹窗时resetFields不生效
        this.$nextTick(() => {
          this.fillForm(row)
        })
      }
      this.handelDialogVisible = true
      this.$refs.form?.clearValidate()
    },
    fillForm(row) {
      for (const i in this.formData) {
        this.formData[i] = row[i]
      }
      // 数据索引，编辑时有用
      this.formData.index = row.index
    },
  },
}
</script>
<style lang='less' scoped>
.irrDiv {
  display: inline-block;
}
</style>
